export const HTTP_RESPONSE_CODE_TOKEN_INVALID = 401
